angular.module('unica_event.event_services')

.factory('EventSendService', function ($http, getBaseApiURL) {

	var eventSendService = {};

	eventSendService.send = function (id, invitationListId) {

		return $http({
			method: 'post',
			url: getBaseApiURL + '/event/send-invitations/' + id + ( invitationListId ? '/' + invitationListId : ''),
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	eventSendService.sendReminder = function (id, invitationListId) {

		return $http({
			method: 'post',
			url: getBaseApiURL + '/event/send-reminder-invitations/' + id + ( invitationListId ? '/' + invitationListId : ''),
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};


	eventSendService.sendSurvey = function (id) {

		return $http({
			method: 'post',
			url: getBaseApiURL + '/event/send-survey/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	return eventSendService;
});